import { hide } from 'redux-modal'
import { push } from 'connected-react-router'
import { PROMOTIONS_DETAIL_MODAL_PAGE } from 'constant'

export const navigateToPromo = path => dispatch => {
  dispatch(hide(PROMOTIONS_DETAIL_MODAL_PAGE))
  setTimeout(() => dispatch(push(path)))
}
